// extracted by mini-css-extract-plugin
export default {"dividerContainer":"BnD5F","horizontal":"_5pfov","orText":"hI9Xf","line":"CuHLz","withMargin":"vnh4F","form":"L6bM-"};